/**
 * Add to cart modal for service contracts - used on PDS(Service Page)
 * "Confirm" button inside the modal adds the service directly to the cart
 */

'use client';

import { useState } from 'react';

import { Button, Checkbox, Dialog, Stack, Text } from '@backyard-ui/core';

import { ServiceContractModalBase } from './ServiceContractModalBase';
import { type Characteristic } from './types';

export type ServiceContractAddToCartProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  characteristics?: Characteristic[];
  onAddToCart?: () => void;
  isLoading?: boolean;
};

function ServiceContractAddToCartModal(
  props: Readonly<ServiceContractAddToCartProps>
) {
  const { isOpen, onOpenChange, title, characteristics, onAddToCart } = props;

  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const toggleCheckbox = () => {
    setIsTermsAccepted((prev) => !prev);
  };

  const handleAddToCart = () => {
    if (isTermsAccepted) {
      onAddToCart?.();
    }
  };

  const footer = (
    <Stack direction="column" className="w-full pb-2">
      <Checkbox size="sm" isChecked={isTermsAccepted} onChange={toggleCheckbox}>
        <Text size="md">Estou ciente e concordo com os termos.</Text>
      </Checkbox>
      <Dialog.Close asChild>
        <Button
          onClick={handleAddToCart}
          isDisabled={!isTermsAccepted}
          isFullWidth
        >
          Confirmar
        </Button>
      </Dialog.Close>
    </Stack>
  );

  return (
    <ServiceContractModalBase
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={title}
      characteristics={characteristics}
      footer={footer}
    />
  );
}

export default ServiceContractAddToCartModal;
